<template>
  <el-container class="module-container auditor-container">
    <template v-if="Auditor.list.hasError">
      <InformationFetchingError :errors="Auditor.list.errors" />
    </template>
    <template v-else>
      <el-header height="auto" class="module-container__header">
        <VisitListHeader :title="getTitle" :on-filter="onFilter">
          <el-breadcrumb-item slot="breadcrumb" :to="{ name: Breadcrumbs.auditors }">
            {{ $t('Team Performance') }}
          </el-breadcrumb-item>
        </VisitListHeader>
      </el-header>
      <el-main>
        <VisitList :list="auditorList"
                   :loading="Auditor.list.isLoading"
                   :meta="getAuditorVisitsMeta"
                   :default-sort="getDefaultSort"
                   :on-filter="onFilter"
                   :on-sort-change="onSortChange"
                   :pagination="pagination"
                   show-store-fields
                   @reportStatus="handleReportStatusChange"
                   @virtual-scroll="handleVirtualScroll">
          <el-button
            v-if="!maskTimeData"
            slot="right-side"
            style="margin-right: 10px;"
            type="primary"
            @click="onExport">
            {{ $t('Export') }}
          </el-button>
        </VisitList>
      </el-main>
    </template>
  </el-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import normalizeVisit from '@/modules/visit/normalizeVisit';
import BackendPaginationMixin from '../../helpers/mixins/backendPagination';
import WorkWithDashboardFilter from '../../helpers/mixins/workWithDashboardFilter';

import VisitList from '../visit/components/List';
import VisitListHeader from '../visit/components/ListHeader';

export default {
  name: 'AuditorShow',
  components: {
    VisitList,
    VisitListHeader
  },
  mixins: [BackendPaginationMixin, WorkWithDashboardFilter],
  props: {
    projectId: {
      type: [String, Number],
      required: true
    },
    auditorId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      reportStatus: [],
      auditorList: []
    };
  },
  computed: {
    ...mapState(['Auditor']),
    getTitle() {
      const { isLoaded } = this.Auditor.active;
      const { name, surname } = this.getActiveData;

      if (!isLoaded) return this.$t('Visits');

      return `${name || ''} ${surname || ''} ${this.$t('Visits')}`;
    },
    getActiveData() {
      return this.Auditor.active.data;
    },
    getAuditorVisitsMeta() {
      return this.Auditor.list.meta;
    }
  },
  watch: {
    reportStatus() {
      this.pagination.currentPage = 1;
      this.fetchData();
    }
  },
  beforeDestroy() {
    this.cleanActiveAuditor();
    this.cleanAuditorVisitList();
  },
  created() {
    const { projectId, auditorId } = this;
    this.fetchAuditor({ projectId, auditorId });
    this.fetchData();
  },
  methods: {
    ...mapActions(['fetchAuditor', 'cleanActiveAuditor', 'cleanAuditorVisitList', 'fetchAuditorVisits', 'exportVisits']),
    async fetchData() {
      const { projectId, auditorId, reportStatus } = this;
      const { selectedFilterScopes, start_time: clientStartTime, end_time: clientEndTime } = this.GlobalFilters.query;
      const start_date_with_time = this.convertToServerTimeZone(`${clientStartTime} 00:00:00`);
      const end_date_with_time = this.convertToServerTimeZone(`${clientEndTime} 23:59:59`);

      const paginationData = {
        ...this.getQuery,
        filter: {
          project: projectId,
          start_date_with_time,
          end_date_with_time,
          ...selectedFilterScopes
        }
      };

      if (!reportStatus.find(item => item === 'all') && reportStatus) {
        paginationData.report_statuses = reportStatus;
      }

      const { data: list } = await this.fetchAuditorVisits({
        projectId,
        auditorId,
        paginationData
      });

      const normalizedList = list.map(normalizeVisit);

      if (this.pagination.currentPage > 1) {
        this.auditorList = [...this.auditorList, ...normalizedList];
      } else {
        this.auditorList = normalizedList;
      }
    },
    onExport() {
      const { projectId } = this;
      const { selectedFilterScopes, start_time: clientStartTime, end_time: clientEndTime } = this.GlobalFilters.query;
      const start_date_with_time = this.convertToServerTimeZone(`${clientStartTime} 00:00:00`);
      const end_date_with_time = this.convertToServerTimeZone(`${clientEndTime} 23:59:59`);

      // eslint-disable-next-line radix
      const auditor_ids = [parseInt(this.auditorId)];

      if (selectedFilterScopes.auditor_ids) {
        delete selectedFilterScopes.auditor_ids;
      }
      const query = {
        filter: {
          start_date_with_time,
          end_date_with_time,
          auditor_ids,
          ...selectedFilterScopes
        }

      };
      this.exportVisits({ projectId, query });
    },
    handleReportStatusChange(status) {
      this.reportStatus = status;
    }
  }
};
</script>

<style lang="scss">
.auditor-container {
  .el-pagination {
    float: right;
  }
}
</style>
